module.exports = __webpack_public_path__ + "img/3.59d35e6b.webp";